<template>
    <div
        class="choose-input"
        :class="{'validate-error':!validateResult,readonly:readonly,invisible:invisible}"
        @dblclick="dblclickHandle"
        @mouseenter="() => this.showClean = true"
        @mouseleave="() => this.showClean = false"
        @mousedown.stop
        @click="clickHandle"
    >
        <div v-if="readonly || invisible" class="readonly-text">
            <div class="content-wrapper" v-html="formatterValue" :title="formatterValue"></div>
        </div>
        <template v-else>
            <input
                v-if="editable"
                :name="options.field"
                :value="formatterValue"
                @change="changeValue"
            />
            <div v-else class="input" :name="options.field" :title="formatterValue">
                <div class="content-wrapper" v-html="formatterValue"></div>
            </div>
            <div class="choose-input-icon" @click="choose">
                <chooseImg v-bind="{color:'#666666',width:'13px',height:'13px'}" />
            </div>
            <div class="choose-input-clean" v-if="isShowClean" @click.stop="cleanValue">
                <fork color="#666" />
            </div>
        </template>
    </div>
</template>
<script>
import Gikam from "../../../core/gikam-core";

export default {
    props: {
        options: Object,
        propValue: String,
        propSetValueAfterChoose: Boolean,
        rowIndex: Number,
        //编辑器中的边框等样式是否显示出来
        propInvisible: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            showClean: false,
            validateResult: true,
            readonly: Gikam.isNotEmpty(this.propReadonly)
                ? this.propReadonly
                : this.options.readonly,
            field: this.options.field,
            value: this.propValue || this.options.value,
            setValueAfterChoose: this.propSetValueAfterChoose || false,
            invisible: this.propInvisible
        };
    },

    inject: ["form", "grid"],

    computed: {
        isShowClean() {
            return this.value && this.showClean;
        },

        editable() {
            return this.options.editable;
        },

        formatterValue() {
            if (this.options.formatter) {
                return this.options.formatter.call(
                    this,
                    this.field,
                    this.value
                );
            } else {
                return this.value;
            }
        }
    },

    watch: {
        value() {
            this.$emit("change", this.options.field, this.value, this.rowIndex);
        },

        propValue(val) {
            this.value = val;
        }
    },

    methods: {
        cleanValue() {
            if (!this.options.onClean) {
                this.value = "";
                return;
            }
            this.options.onClean.call(
                this.form || this.grid,
                this.options.field,
                this.value,
                this.rowIndex
            );
        },

        changeValue(e) {
            this.value = e.target.value;
        },

        choose() {
            if (this.options.onChoose) {
                this.options.onChoose.apply(this.form || this.grid);
                return;
            }
            let category = this.options.category;
            if (this.options.getCategory) {
                category = this.options.getCategory();
            }
            let config = Gikam.choose.getConfig(category);
            let url = Gikam.IFM_CONTEXT + config.url;
            let customData = null;
            if (this.options.onBeforeChoose) {
                customData = this.options.onBeforeChoose.apply(
                    this.form || this.grid,
                    [this.rowIndex]
                );
            }
            if (customData === false) {
                return;
            }
            const requestData = Gikam.deepExtend(customData);
            const _this = this;
            this.options.single && (requestData.single = 1);
            Gikam.create("modal", {
                title: config.title,
                url: url + Gikam.param(requestData),
                width: config.width,
                height: config.height,
                onAfterClose: function(rows) {
                    if (_this.setValueAfterChoose && Gikam.isNotEmpty(rows)) {
                        _this.value = Gikam.getFieldValue(rows[0], _this.field);
                    }
                    _this.$emit("afterChoose", rows, _this.rowIndex);
                }
            });
        },

        dblclickHandle() {
            this.$emit("dblclick", this);
        },

        clickHandle() {
            this.$emit("click", this);
        }
    }
};
</script>

<style scoped>
.choose-input {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: stretch;
    position: relative;
}

.choose-input input,
.choose-input .input,
.choose-input .readonly-text {
    width: 100%;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding-right: 30px;
    padding-left: 8px;
    color: rgba(0, 0, 0, 0.65);
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    height: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
}

.choose-input .readonly-text {
    position: absolute;
    padding-right: 8px;
}

.choose-input .input >>> p {
    margin: 0;
}

.choose-input .content-wrapper {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.choose-input .input >>> a,
.choose-input .readonly-text >>> a {
    color: #007aff;
    text-decoration: none;
}

.choose-input .readonly-text {
    background-color: #f4f4f4;
    display: flex;
    align-items: center;
}

.choose-input input:focus {
    border: 1px solid rgba(0, 122, 255, 0.5);
}

.choose-input.validate-error input,
.choose-input.validate-error .input {
    border-color: #ff6e6e;
}

.choose-input .choose-input-icon {
    width: 30px;
    cursor: pointer;
    margin-left: -30px;
    background-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.choose-input .choose-input-clean {
    position: absolute;
    right: 20px;
    width: 20px;
    height: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.choose-input .choose-input-clean svg {
    height: 8px;
}

.invisible .readonly-text {
    background-color: transparent;
    border: none;
}
</style>